export const ENTITY_TIME_STAMP_KEY = '_createdAt';
